<template>
  <div class="classroom-add">
    <el-dialog
      title="添加敏感词"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="480px"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="内容:" prop="word">
            <el-input
              v-model="ruleForm.word"
              placeholder="请输入敏感词"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型:" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择类型">
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    options: {
      type: Array,
    },
  },
  data() {
    return {
      ruleForm: {
        word: "",
        type: "",
      },
      rules: {
        word: [{ required: true, message: "请输入敏感词", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  inject: ["refresh"],
  created() {},
  methods: {
    dialogOpen() {
      this.ruleForm.word = "";
      this.ruleForm.type = "";
    },
    dialogClose() {
      this.ruleForm.word = "";
      this.ruleForm.type = "";
      this.$emit("update:dialogVisible", false);
      this.$refs["ruleForm"].clearValidate();//移除表单检验结果
    },
    confirm() {
      // 验证信息是否完整
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.post(this.$url.insert, {
            createBy: this.user.id.toString(), //添加人id
            word: this.ruleForm.word, //敏感字
            type: this.ruleForm.type, //敏感字类型
            schoolId: this.user.schoolId,
            schoolName: this.user.schoolName,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200 && res.data != 0) {
                this.$message.success(res.msg);
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(res.msg);
              // console.log(err);
            });
          // 刷新列表
          this.refresh();
          // 关闭弹出框
          this.dialogClose();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped >
@import "./sensitiveWord-add.scss";
</style>